import React from 'react';
import Modal from '@mui/material/Modal';
import { tWithFallback } from '../../Utills/translations';
import './style.css';

const WhatsAppModal = ({ open, onClose, onConfirm }) => (
  <Modal
    open={open}
    onClose={onClose}
    aria-labelledby="whatsapp-modal-title"
    closeAfterTransition
  >
    <div className="whatsapp-modal-box">
      <div className="whatsapp-modal-inner">
        <button className="whatsapp-modal-close" onClick={onClose}>×</button>

        <div className="whatsapp-modal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64">
            <defs>
              <linearGradient id="wpp-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#25D366" />
                <stop offset="100%" stopColor="#128C7E" />
              </linearGradient>
            </defs>
            <path
              fill="url(#wpp-gradient)"
              d="M12 2C6.48 2 2 6.48 2 12c0 1.86.48 3.63 1.38 5.21L2 22l4.79-1.38A9.98 9.98 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.7 0-3.33-.48-4.76-1.38l-.34-.2-2.85.82.82-2.85-.2-.34A7.96 7.96 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z"
            />
            <path
              fill="url(#wpp-gradient)"
              d="M16.4 13.8c-.2-.1-1.2-.6-1.4-.7-.2-.1-.3-.1-.5.1-.1.2-.6.7-.7.9-.1.1-.2.1-.4 0-.2-.1-.9-.3-1.7-1-.6-.5-1-1.1-1.1-1.3-.1-.2 0-.3.1-.4.1-.1.2-.3.3-.4.1-.1.1-.2.1-.3 0-.1-.1-.2-.2-.4-.1-.2-.5-1.1-.7-1.5-.2-.4-.4-.3-.5-.3h-.4c-.1 0-.3.1-.5.2-.2.1-.7.7-.7 1.7 0 1 .7 2 1 2.1.2.1 1.7 2.7 4.1 3.7.6.3 1 .4 1.4.5.6.1 1.1.1 1.5-.1.5-.2 1.2-.9 1.4-1.7.2-.8.2-1.5.1-1.6-.1-.2-.2-.3-.4-.4z"
            />
          </svg>
        </div>

        <h2 id="whatsapp-modal-title" className="whatsapp-modal-title">
          {tWithFallback('whatsappSuporte')}
        </h2>

        <p className="whatsapp-modal-description">
          {tWithFallback('whatsappDescricao')}
          <br />
          {tWithFallback('whatsappPrivacidade')}
        </p>

        <div className="whatsapp-modal-terms">
          {tWithFallback('whatsappTermos')}{' '}
          <a
            href="https://login.net4guest.com/disclaimer/disclaimer_pt.php"
            target="_blank"
            rel="noopener noreferrer"
          >
            {tWithFallback('whatsappTermosLink')}
          </a>
        </div>

        <div className="whatsapp-modal-actions">
          <button className="whatsapp-modal-btn-confirm" onClick={onConfirm}>
            {tWithFallback('whatsappContinuar')}
          </button>
          <button className="whatsapp-modal-btn-cancel" onClick={onClose}>
            {tWithFallback('whatsappCancelar')}
          </button>
        </div>
      </div>
    </div>
  </Modal>
);

export default WhatsAppModal;
